module.exports = __webpack_public_path__ + "static/img/26.c06b5064.jpg";